import { render, staticRenderFns } from "./storageRecord.vue?vue&type=template&id=3e1ad49c&scoped=true&"
import script from "./storageRecord.vue?vue&type=script&lang=js&"
export * from "./storageRecord.vue?vue&type=script&lang=js&"
import style0 from "./storageRecord.vue?vue&type=style&index=0&id=3e1ad49c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1ad49c",
  null
  
)

export default component.exports